import { Outlet, ScrollRestoration } from 'react-router';
import { Header } from '../components/Header/Header';
import { useFetchGlobalAdmin } from '../hooks/useFetchGlobalAdmin';

export const RootLayout = () => {
  useFetchGlobalAdmin();

  return (
    <>
      {/*
          ScrollRestoration component automatically restores the scroll
          position when navigating between pages
      */}
      <ScrollRestoration />

      <Header />
      <Outlet />
    </>
  );
};
